import config from 'config';

export const getDocumentDownloadLink = (orderId, documentId) =>
  `${config.api.baseUrlDownload || config.api.baseUrl}${
    config.api.url
  }/orders/${orderId}/documents/${documentId}`;

export default getDocumentDownloadLink;
